import React, {useState, useEffect, useRef} from 'react'
import style from "./ServicesMainPage.module.scss";
import ContactUs from "../ContactUs/ContactUs.jsx";
import KeyContact from "../KeyContact/KeyContact.jsx";
import GoogleMap from "../GoogleMap/GoogleMap.jsx";
import FormFeedback from "../FormFeedback/FormFeedback.jsx";
import ButtonClose from "../ButtonClose/ButtonClose.jsx";
import UAE from './../../assets/UAE.jpg'
import Kazakhstan from './../../assets/Kazakhstan.jpg'
import Uzbekistan from './../../assets/Uzbekistan.jpg'
import HongKong from './../../assets/HongKong.jpg'


export default function ServicesMainPage({teamsData, activeCategory, setActiveCategory, isHidden, setIsHidden}) {
    const [activeInformation, setActiveInformation] = useState('1');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeInformation]);

    const handleCategoryClick = (category) => {
        if (activeCategory === category) {
            setActiveCategory(null);
        } else {
            setActiveCategory(category);
        }
    };

    const formRef = useRef(null);
    const formRefBlock = useRef(null);

    useEffect(() => {
        if (activeCategory === 'contacts') {
            formRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }, [activeCategory]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [formRefBlock]);

    return (
        <div ref={formRef } className={style.services}>
        <div className={style.servicesBg}></div>
        <div style={{height: '100%'}}>
            <div
                className={`${style.corporatePractice} ${activeCategory === 'corporatePractice' ? style.corporatePractice__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <h3 className={style.title}>Корпоративное управление</h3>
                    <p className={style.text}>Представляет собой сложный процесс, который во многом определяет
                        эффективность и прибыльность
                        компании. Мы гарантируем надежное и профессиональное сопровождение корпоративных процессов,
                        что позволяет нашим клиентам сосредоточиться на основной деятельности и достичь успеха в
                        своих бизнес-целях.</p>
                    <h3 className={style.title}>Корпоративная практика нашей фирмы - одна из самых ключевых и
                        динамичных:</h3>
                    <h4 className={style.subtitle}>Создание и реструктуризация бизнеса:</h4>
                    <p className={`${style.text} ${style.point}`}>Проведение аудита юридических рисков проекта;</p>
                    <p className={`${style.text} ${style.point}`}>Подбор удобной налоговой модели;</p>
                    <p className={`${style.text} ${style.point}`}>Консультации по нормам российского или
                        иностранного права;</p>
                    <p className={`${style.text} ${style.point}`}>Разработка оптимальной корпоративной структуры с
                        учетом интересов разных
                        групп владельцев
                        бизнеса;</p>
                    <p className={`${style.text} ${style.point}`}>Разработка правовой архитектуры запуска;</p>
                    <p className={`${style.text} ${style.point}`}>Анализ эффективности существующей корпоративной
                        структуры;</p>
                    <p className={`${style.text} ${style.point}`}>Реструктуризация существующего бизнеса, с учетом
                        санкций 2022-2023.</p>
                    <h4 className={style.subtitle}>Юридические лица (ЮЛ):</h4>
                    <p className={`${style.text} ${style.point}`}>Сопровождение процесса регистрации ЮЛ различных
                        форм (АО, ООО и др.);</p>
                    <p className={`${style.text} ${style.point}`}>Внесение изменений (смена наименования,
                        увеличение/уменьшение уставного
                        капитала, смена
                        юридического адреса, внесение изменений в ЕГРЮЛ; внесение изменений в Устав, вход (ввод)
                        нового
                        участника, смена кодов ОКВЭД);</p>
                    <p className={`${style.text} ${style.point}`}>Реорганизация ЮЛ путем слияния, разделения,
                        выделения, преобразования,
                        присоединения;</p>
                    <p className={`${style.text} ${style.point}`}>Комплексное сопровождение процедуры ликвидации
                        ЮЛ.</p>
                    <h3 className={`${style.text} ${style.point}`}>С января 2023 года мы запустили услугу
                        «корпоративный секретарь»
                        (SQN-CorpSec).</h3>
                    <h4 className={style.subtitle}>SQN-CorpSec это:</h4>
                    <p className={`${style.text} ${style.point}`}>Профессиональная юридическая поддержка ваших
                        бизнес-процессов на
                        постоянной основе.</p>
                    <p className={`${style.text} ${style.point}`}>Медиация корпоративных конфликтов и тупиковых
                        ситуаций, профилактика их
                        наступления.</p>
                    <p className={`${style.text} ${style.point}`}>Полная конфиденциальность информации.</p>
                    <p className={`${style.text} ${style.point}`}>Экспертная поддержка при разрешении споров между
                        участниками и
                        обществом.</p>
                    <p className={`${style.text} ${style.point}`}>Настройка баланса корпоративного управления на
                        разных уровнях:
                        собственники бизнеса, совет
                        директоров, генеральный директор и прочие звенья.</p>
                    <p className={`${style.text} ${style.point}`}>Консультации по корпоративному управлению: будьте
                        в курсе передовой
                        практики управления и
                        принимайте взвешенные решения.</p>
                    <p className={`${style.text} ${style.point}`}>Подготовка и проведение собраний: Мы позаботимся о
                        планировании,
                        подготовке повестки дня,
                        оформлении бюллетеней, протоколов заседаний совета директоров и собраний
                        участников/акционеров.</p>
                    <p className={`${style.text} ${style.point}`}>Соответствие нормативным требованиям: Обеспечьте
                        соответствие компании
                        законодательным
                        требованиям благодаря нашему тщательному мониторингу.</p>
                    <p className={`${style.text} ${style.point}`}>Ведение корпоративной документации: От реестров
                        акций до годовых отчетов и
                        корпоративных
                        договоров - мы обеспечиваем эффективное управление важнейшими корпоративными
                        документами.</p>
                    <h3 className={style.title}>Действуя как Корпоративный секретарь, наша фирма сопровождает
                        порядка 20
                        юридических лиц одновременно.</h3>
                </div>
                <KeyContact teamsData={teamsData}/>
                <ContactUs setActiveCategory={setActiveCategory}/>
            </div>
            <div style={{zIndex: isHidden ? '3' : '1'}}
                 className={`${style.transactions} ${activeCategory === 'transactions' ? style.transactions__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <h4 className={style.subtitle}>Наша фирма оказывает комплексное сопровождение
                        сделок различного уровня
                        сложности по приобретению / продаже бизнесов, активов компаний, реструктуризации групп компаний,
                        проведению due diligence, получению согласований органов государственной власти, а также иных
                        услуг в рамках M&A процедур.

                        Команда фирмы обладает большим опытом в сопровождении сложных сделок в различных отраслях
                        экономики (в том числе в области природных ресурсов и промышленности, машиностроения, финансовых
                        рынков) и формирует правовые решения под конкретные цели клиентов, коммерческие и управленческие
                        договоренности.</h4>
                    <h4 className={style.subtitle}>Услуги:</h4>
                    <p className={`${style.text} ${style.point}`}>Консультационные услуги по структуре сделки (от
                        разработки структуры сделки «с нуля» до анализа сделки, предложенной клиентом, с оценкой
                        рисков);</p>
                    <p className={`${style.text} ${style.point}`}>Комплексная правовая и финансовая экспертиза
                        приобретаемого/ продаваемого бизнеса/активов;</p>
                    <p className={`${style.text} ${style.point}`}>Получение согласований в государственных органах (ФАС
                        России, Правительственная комиссия, согласования требуемые в соответствии с указами Президента
                        РФ);</p>
                    <p className={`${style.text} ${style.point}`}>Подготовка полного комплекта документов для сделки
                        (договоры купли-продажи, соглашения о предоставлении опционов / опционные соглашения, соглашения
                        о возмещении потерь, независимые гарантии и т.д.);</p>
                    <p className={`${style.text} ${style.point}`}>Правовое сопровождение процедуры «закрытия» сделки и
                        выполнения «post-closing» условий;</p>
                    <p className={`${style.text} ${style.point}`}>Участие в переговорах, представление интересов клиента
                        в государственных органах.</p>
                    <h4 className={style.subtitle}>Примеры сделок:</h4>
                    <p className={`${style.text} ${style.point}`}>M&A;</p>
                    <p className={`${style.text} ${style.point}`}>Создание совместных предприятий (JV);</p>
                    <p className={`${style.text} ${style.point}`}>Сделки с недвижимостью и земельными участками;</p>
                    <p className={`${style.text} ${style.point}`}>Перекрестное владение активами;</p>
                    <p className={`${style.text} ${style.point}`}>Рамочные договоры;</p>
                    <p className={`${style.text} ${style.point}`}>Поставка, лизинг, подряд, аренда; Поручительство и
                        гарантии;</p>
                    <p className={`${style.text} ${style.point}`}>Корпоративные договоры;</p>
                    <p className={`${style.text} ${style.point}`}>Опционы.</p>

                    <h4 className={style.subtitle}>Ценные бумаги:</h4>
                    <p className={`${style.text} ${style.point}`}>Сопровождение сделок с ценными бумагами (дарение,
                        купля-продажа, передача в управление, мена и др.);</p>
                    <p className={`${style.text} ${style.point}`}>Эмиссия акций/облигаций;</p>
                    <p className={`${style.text} ${style.point}`}>Сопровождение процедур выкупа ценных бумаг;</p>
                    <p className={`${style.text} ${style.point}`}>Содействие при проведении аудиторской
                        деятельности;</p>
                    <p style={{marginBottom: '50px'}} className={`${style.text} ${style.point}`}>Сопровождение сделок с
                        паями инвестиционных фондов.</p>
                </div>
                <KeyContact teamsData={teamsData}/>
                <ContactUs setActiveCategory={setActiveCategory}/>
            </div>
            <div style={{zIndex: isHidden ? '3' : '1'}}
                 className={`${style.public_privatePartnership} ${activeCategory === 'public-privatePartnership' ? style.public_privatePartnership__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <h4 className={style.subtitle}>Юристы SQN обладают многолетним опытом сопровождения ГЧП проектов.
                        Основу нашей практики ГЧП составляют проекты в социальной сфере (школы, поликлиники,
                        спортивные сооружения), проекты жилищно-коммунального хозяйства (ТКО, прочие тарифные ЖКХ
                        проекты) и проекты в сфере инфраструктуры (парковки, фото-видео-фиксация, объекты дорожного
                        хозяйства).</h4>
                    <h4 className={style.subtitle}>SQN предоставляет полную поддержку в реализации проекта ГЧП. Наши
                        юристы помогают оформить все необходимые документы, проводят анализ рисков и защищают интересы
                        клиента в процессе сотрудничества с публичным партнером и кредитными организациями.</h4>
                    <h4 className={style.subtitle}>Юридические услуги по комплексному организационно-правовому
                        сопровождению проектов в сфере ГЧП включают:</h4>
                    <p className={`${style.text} ${style.point}`}>Помощь в выборе оптимальной формы ГЧП для конкретного
                        проекта;</p>
                    <p className={`${style.text} ${style.point}`}>Разработка концепции концессионного соглашения/ГЧП
                        проекта;</p>
                    <p className={`${style.text} ${style.point}`}>Подготовка предложения о заключении концессионного
                        соглашения или соглашения о ГЧП/МЧП;</p>
                    <p className={`${style.text} ${style.point}`}>Консультирование по вопросам нормотворчества и
                        внесения изменений в действующее нормативное регулирование;</p>
                    <p className={`${style.text} ${style.point}`}>Подготовка заявок и конкурсных предложений и
                        юридическое сопровождение участия в конкурсных процедурах;</p>
                    <p className={`${style.text} ${style.point}`}>Проведение переговоров и согласование итоговых условий
                        концессионного соглашения или соглашения о ГЧП/МЧП;</p>
                    <p className={`${style.text} ${style.point}`}>Корпоративные вопросы: подготовка проектных компаний
                        под проекты ГЧП;</p>
                    <p className={`${style.text} ${style.point}`}>Взаимодействие с ведущими банками и
                        специализированными организациями для согласования условий финансирования проекта;</p>
                    <p style={{marginBottom: '50px'}} className={`${style.text} ${style.point}`}>Юридическое
                        сопровождение коммерческого и финансового закрытий проекта.</p>
                </div>
                <KeyContact teamsData={teamsData}/>
                <ContactUs setActiveCategory={setActiveCategory}/>
            </div>
            <div style={{zIndex: isHidden ? '3' : '1'}}
                 className={`${style.internationalPractice} ${activeCategory === 'internationalPractice' ? style.internationalPractice__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <div className={style.internationalPracticeListContainer}>
                        <div className={style.internationalPracticeList}>
                            <div onClick={() => {
                                setActiveInformation('1');
                            }} className={`${style.city} ${activeInformation === '1' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${UAE})`}}><span>Объединенные арабские эмираты</span>
                            </div>
                            <div onClick={() => {
                                setActiveInformation('2');
                            }}
                                 className={`${style.city} ${activeInformation === '2' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${Kazakhstan})`}}><span>Казахстан</span>
                            </div>
                            <div onClick={() => {
                                setActiveInformation('3');
                            }}
                                 className={`${style.city} ${activeInformation === '3' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${Uzbekistan})`}}><span>Узбекистан</span>
                            </div>
                            <div onClick={() => {
                                setActiveInformation('4');
                            }}
                                 className={`${style.city} ${activeInformation === '4' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${UAE})`}}><span>Индия</span>
                            </div>
                            <div onClick={() => {
                                setActiveInformation('5');
                            }}
                                 className={`${style.city} ${activeInformation === '5' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${HongKong})`}}><span>Гонконг (Китай)</span>
                            </div>
                            <div onClick={() => {
                                setActiveInformation('6');
                            }}
                                 className={`${style.city} ${activeInformation === '6' ? style.activeCity : ''}`}
                                 style={{backgroundImage: `url(${UAE})`}}><span>Локализация в иных юрисдикциях</span>
                            </div>
                        </div>
                        <div className={style.internationalPracticeInformation}>
                            {activeInformation === '1' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>ОАЭ является одним из
                                        наиболее динамично
                                        развивающихся регионов мира, что предоставляет бизнесу множество возможностей
                                        для роста и развития.</h4>
                                    <p style={{fontWeight: '600', textTransform: 'uppercase'}}
                                       className={`${style.text}`}>Локализация в ОАЭ:</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам
                                        законодательства и налогообложения ОАЭ, а также по процедуре регистрации и
                                        лицензирования бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка документов для регистрации
                                        компании в ОАЭ, включая оформление учредительных документов, регистрацию и
                                        получение необходимых лицензий и разрешений;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в поиске и выборе подходящего
                                        офиса (включая flexi-desk офисы) или склада для бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами;</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам трудового
                                        законодательства, а также помощь в оформлении рабочих виз и разрешений на работу
                                        для иностранных сотрудников;</p>
                                    <p className={`${style.text} ${style.point}`}>Получение и переоформление Emirates
                                        ID;</p>
                                    <p className={`${style.text} ${style.point}`}>Юридическая поддержка при сделках с
                                        недвижимостью и инвестициях;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в открытии банковских счетов и
                                        обслуживании банковских операций;</p>
                                    <p className={`${style.text} ${style.point}`}>Юридическая поддержка при решении
                                        споров с государственными органами или другими компаниями в ОАЭ.</p>
                                </div>
                            ) : null}
                            {activeInformation === '2' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>Казахстан – одна из
                                        немногих юрисдикций, открытых для российского капитала и транзита товаров,
                                        благодаря наличию единого таможенного пространства (ТС), а также широкой общей
                                        сухопутной границе с Россией. Русский язык является официальным. Местное
                                        законодательство имеет высокую степень преемственности от норм российского
                                        права.</h4>
                                    <p style={{fontWeight: '600', textTransform: 'uppercase'}}
                                       className={`${style.text}`}>Локализация в Казахстане:</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам местного
                                        законодательства, включая вопросы регистрации и ведения бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка документов для регистрации
                                        компании в Казахстане, включая оформление учредительных документов, регистрацию
                                        и получение необходимых разрешений;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в поиске и выборе подходящего
                                        офиса или склада для бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами, включая международные поставки и дилерские
                                        контракты;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в открытии банковских счетов и
                                        обслуживании банковских операций;
                                    </p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в локализации на территории
                                        свободных экономических зон Казахстана;</p>
                                    <p className={`${style.text} ${style.point}`}>Юридическая поддержка при решении
                                        споров с государственными органами или другими компаниями в Казахстане.</p>
                                </div>
                            ) : null}
                            {activeInformation === '3' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>Узбекистан – наиболее
                                        дружественная к России юрисдикция в Центральной Азии, имеющая к тому же
                                        динамично развивающуюся экономику при низкой базе, что обеспечивает кратные
                                        показатели роста в бизнесе в текущих условиях.</h4>
                                    <p style={{fontWeight: '600', textTransform: 'uppercase'}}
                                       className={`${style.text}`}>Локализация в Узбекистане:</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам местного
                                        законодательства, включая вопросы регистрации и ведения бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка документов для регистрации
                                        компании в Узбекистане, включая оформление учредительных документов, регистрацию
                                        и получение необходимых разрешений;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в поиске и выборе подходящего
                                        офиса или склада для бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами, включая международные поставки и дилерские
                                        контракты;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в открытии банковских счетов и
                                        обслуживании банковских операций;</p>
                                    <p className={`${style.text} ${style.point}`}>Юридическая поддержка при решении
                                        споров с государственными органами или другими компаниями в Узбекистане.</p>

                                </div>
                            ) : null}
                            {activeInformation === '4' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>Индия – 6-ая экономика
                                        мира по ВВП. Индия имеет колоссальный внутренний рынок, сложившуюся правовую
                                        базу на основе английского права, а также опыт международной торговли и
                                        осуществления финансовых операций.</h4>
                                    <p style={{fontWeight: '600', textTransform: 'uppercase'}}
                                       className={`${style.text}`}>Локализация в Индии:</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам местного
                                        законодательства, включая вопросы регистрации и ведения бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Налоговый консалтинг и
                                        структурирование финансовых потоков;</p>
                                    <p className={`${style.text} ${style.point}`}>Разработка юридических структур под
                                        нужды бизнеса в Индии, включая использование номинальных директоров и
                                        акционеров;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка документов для регистрации
                                        компании в Индии, включая оформление учредительных документов, регистрацию и
                                        получение необходимых разрешений;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в поиске и выборе подходящего
                                        офиса или склада для бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами, включая международные поставки и дилерские
                                        контракты;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в открытии банковских счетов и
                                        обслуживании банковских операций;</p>
                                    <p className={`${style.text} ${style.point}`}>Юридическая поддержка при решении
                                        споров с государственными органами или другими компаниями в Индии.</p>
                                </div>
                            ) : null}
                            {activeInformation === '5' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>Ведущий мировой
                                        финансовый центр, имеющий устойчивое правовое регулирование. Гонконг, являясь
                                        самостоятельным звеном в международной торговле, имеет тесные связи как с
                                        материковым Китаем, так и с финансовыми рынками Азии и Запада, что позволяет
                                        бизнесу достигать самых амбициозных целей.</h4>
                                    <p style={{fontWeight: '600', textTransform: 'uppercase'}}
                                       className={`${style.text}`}>Локализация в Гонконге:</p>
                                    <p className={`${style.text} ${style.point}`}>Консультации по вопросам местного
                                        законодательства, включая вопросы регистрации и ведения бизнеса;</p>
                                    <p className={`${style.text} ${style.point}`}>Налоговый консалтинг и
                                        структурирование финансовых потоков;</p>
                                    <p className={`${style.text} ${style.point}`}>Разработка юридических структур под
                                        нужды бизнеса в Гонконге, включая использование номинальных директоров и
                                        акционеров;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка документов для регистрации
                                        компании в Гонконге, включая оформление учредительных документов, регистрацию и
                                        получение необходимых разрешений;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в поиске и выборе подходящего
                                        офиса, включая flexi-desk офисы;</p>
                                    <p className={`${style.text} ${style.point}`}>Подготовка договоров с поставщиками,
                                        партнерами и клиентами, включая международные поставки и дилерские
                                        контракты;</p>
                                    <p className={`${style.text} ${style.point}`}>Помощь в открытии банковских счетов в
                                        китайских банках.</p>
                                </div>
                            ) : null}
                            {activeInformation === '6' ? (
                                <div className={style.informationContainer}>
                                    <h4 style={{paddingRight: '80px'}} className={style.subtitle}>SQN сопровождает
                                        сделки по локализации бизнеса и в иных юрисдикциях. Опишите нам задачу вашего
                                        бизнеса, а мы подготовим подходящее решение.</h4>
                                    <div className={style.contactUs}>
                                        <ContactUs setActiveCategory={setActiveCategory}/>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                <KeyContact teamsData={teamsData}/>
                <ContactUs setActiveCategory={setActiveCategory}/>
            </div>
            <div style={{zIndex: isHidden ? '3' : '1'}}
                 className={`${style.specialAssignments} ${activeCategory === 'specialAssignments' ? style.specialAssignments__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <h3 className={style.title}>Особые поручения – персональные решения для наших клиентов по личным,
                        узкопрофильным вопросам. Доверительно, конфиденциально и профессионально.</h3>

                    <h4 className={style.subtitle}>Примеры особых поручений:</h4>
                    <p className={`${style.text} ${style.point}`}>Брачные договоры, раздел активов супругов,
                        наследственные дела;</p>
                    <p className={`${style.text} ${style.point}`}>Представительство в рамках административных и
                        уголовных дел, включая срочные вызовы;</p>
                    <p className={`${style.text} ${style.point}`}>Медиация непубличных конфликтов;</p>
                    <p className={`${style.text} ${style.point}`}>Открытие счетов в иностранных банках, консультирование
                        по вопросам ведения счетов;</p>
                    <p className={`${style.text} ${style.point}`}>Приобретение активов в зарубежных юрисдикциях;</p>
                    <p style={{marginBottom: '50px'}} className={`${style.text} ${style.point}`}>Создание персональных
                        холдинговых структур и трастов.</p>
                </div>
                <KeyContact teamsData={teamsData}/>
                <ContactUs setActiveCategory={setActiveCategory}/>
            </div>
            <div ref={formRefBlock} style={{zIndex: isHidden ? '3' : '1'}}
                 className={`${style.contacts} ${activeCategory === 'contacts' ? style.contacts__open : ""}`}>
                <div className='container'>
                    <ButtonClose className={style.buttonClose} setActiveCategory={setActiveCategory}/>
                    <h4 className={style.subtitleWhite}>Чтобы отправить нам сообщение, пожалуйста,
                        заполните форму
                        ниже:</h4>
                    <FormFeedback/>
                    <h3 className={style.titleWhite}>Контакты</h3>
                    <div className={style.contactsList}>
                        <div className={style.contactsItem}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M20.6201 8.45C19.5701 3.83 15.5401 1.75 12.0001 1.75C12.0001 1.75 12.0001 1.75 11.9901 1.75C8.4601 1.75 4.4201 3.82 3.3701 8.44C2.2001 13.6 5.3601 17.97 8.2201 20.72C9.2801 21.74 10.6401 22.25 12.0001 22.25C13.3601 22.25 14.7201 21.74 15.7701 20.72C18.6301 17.97 21.7901 13.61 20.6201 8.45ZM12.0001 13.46C10.2601 13.46 8.8501 12.05 8.8501 10.31C8.8501 8.57 10.2601 7.16 12.0001 7.16C13.7401 7.16 15.1501 8.57 15.1501 10.31C15.1501 12.05 13.7401 13.46 12.0001 13.46Z"
                                    fill="#D11018"/>
                            </svg>
                            <span className={style.contactsLink}>Москва, Большой Гнездниковский переулок 1с2</span>
                        </div>
                        <div className={style.contactsItem}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M11.05 14.95L9.2 16.8C8.81 17.19 8.19 17.19 7.79 16.81C7.68 16.7 7.57 16.6 7.46 16.49C6.43 15.45 5.5 14.36 4.67 13.22C3.85 12.08 3.19 10.94 2.71 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C10.83 13.32 10.94 13.42 11.04 13.52C11.44 13.91 11.45 14.55 11.05 14.95Z"
                                    fill="#D11018"/>
                                <path
                                    d="M21.9696 18.33C21.9696 18.61 21.9196 18.9 21.8196 19.18C21.7896 19.26 21.7596 19.34 21.7196 19.42C21.5496 19.78 21.3296 20.12 21.0396 20.44C20.5496 20.98 20.0096 21.37 19.3996 21.62C19.3896 21.62 19.3796 21.63 19.3696 21.63C18.7796 21.87 18.1396 22 17.4496 22C16.4296 22 15.3396 21.76 14.1896 21.27C13.0396 20.78 11.8896 20.12 10.7496 19.29C10.3596 19 9.96961 18.71 9.59961 18.4L12.8696 15.13C13.1496 15.34 13.3996 15.5 13.6096 15.61C13.6596 15.63 13.7196 15.66 13.7896 15.69C13.8696 15.72 13.9496 15.73 14.0396 15.73C14.2096 15.73 14.3396 15.67 14.4496 15.56L15.2096 14.81C15.4596 14.56 15.6996 14.37 15.9296 14.25C16.1596 14.11 16.3896 14.04 16.6396 14.04C16.8296 14.04 17.0296 14.08 17.2496 14.17C17.4696 14.26 17.6996 14.39 17.9496 14.56L21.2596 16.91C21.5196 17.09 21.6996 17.3 21.8096 17.55C21.9096 17.8 21.9696 18.05 21.9696 18.33Z"
                                    fill="#D11018"/>
                            </svg>
                            <a className={style.contactsLink} href="tel:+74997058878">+7 499 705 88 78</a>
                        </div>
                        <div className={style.contactsItem}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
                                    fill="#D11018"/>
                            </svg>
                            <a className={style.contactsLink} href="mailto:info@sqn-law.ru">info@sqn-law.ru</a>
                        </div>
                    </div>
                    <GoogleMap style={{marginBottom: '20px'}}/>
                </div>
            </div>
        </div>
            <div className={style.linksServices}>
                <div className='containerLinks'>
                    <div className={style.innerContainer}>
                    <div style={{backgroundColor: activeCategory === 'corporatePractice' ? '#891515' : '#202020'}}
                         className={style.link}
                         onClick={() => {
                             handleCategoryClick('corporatePractice');
                             setIsHidden(true);
                         }}>Корпоративная <br/> практика
                    </div>
                    <div style={{backgroundColor: activeCategory === 'transactions' ? '#891515' : '#191919'}}
                         onClick={() => {
                             handleCategoryClick('transactions');
                             setIsHidden(true);
                         }} className={`${style.link} ${style.linkColor}`}>M&A
                    </div>
                    <div
                        style={{backgroundColor: activeCategory === 'public-privatePartnership' ? '#891515' : '#202020'}}
                        onClick={() => {
                            handleCategoryClick('public-privatePartnership');
                            setIsHidden(true);
                        }}
                        className={style.link}>ГЧП
                    </div>
                    <div style={{backgroundColor: activeCategory === 'internationalPractice' ? '#891515' : '#191919'}}
                         onClick={() => {
                             handleCategoryClick('internationalPractice');
                             setIsHidden(true);
                         }}
                         className={`${style.link} ${style.linkColor}`}>Международная <br/> практика
                    </div>
                    <div style={{backgroundColor: activeCategory === 'specialAssignments' ? '#891515' : '#202020'}}
                         onClick={() => {
                             handleCategoryClick('specialAssignments');
                             setIsHidden(true);
                         }}
                         className={style.link}>Особые <br/> поручения
                    </div>
                    <div style={{
                        backgroundColor: activeCategory === 'contacts' ? '#891515' : '#191919'
                    }}
                         onClick={() => {
                             handleCategoryClick('contacts');
                             setIsHidden(true);
                         }}
                         className={style.link}>Контакты
                    </div>
                </div>
            </div>
        </div>
    </div>)
}


